//TODO почему это здесь MapEvent должен находится в типах core
// Событие карты
export enum MapEvent {
  ZOOMEND = 'zoomend' // Окончание зума
}
